import React, { Component } from 'react';
import logo from 'assets/images/logo_top.png';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import IconMenu from '@material-ui/icons/Menu';
import { withRouter } from 'react-router-dom'


import 'react-sticky-header/styles.css';
import StickyHeader from 'react-sticky-header';
import HeaderMenu from './HeaderMenu';
import HeaderLogin from './HeaderLogin';

class Header extends Component {
  render() {
    // const size = 28;
// console.log(URI)
//
// const st = '/preview/a/fiche/7e2d42401e0ef8f1670b6070e3bbad87'
// console.log('DEBUG', /preview\/a\/fiche/.test(this.props.location.search));

// console.log('DEBUG3', URI)
// console.log('DEBUG1', this.props.location)
// console.log('DEBUG2',  (/preview\/a\/fiche/.test(this.props.location.pathname)))
//


if (/preview\/a\/fiche/.test(this.props.location.pathname)) {
  document.body.classList.add('embeded');
  return <span id="header" style={{height: 0}}></span>
}

    const { onPanelToggle } = this.props;
    const menuSize = ['sm', 'xs'].indexOf(this.props.width) < 0 ? 40 : 28;
    return (
      <StickyHeader className="HeaderWrapper"
        header={
          <header id="header" className="Header">
            <Grid container spacing={0} alignItems="center" justify="space-around" style={{height: '100%'}}>
              <Grid item xs className="HeaderLogo">
                <Hidden smUp>
                  <IconMenu className="burger" onClick={onPanelToggle}/>
                </Hidden>
                <a href="/"><img src={logo} alt="logo" height={60}/></a>
              </Grid>
              <Hidden xsDown>

              <Grid item xs={12} md={9} lg={8} style={{textAlign: 'center'}}>
                <HeaderMenu menuSize={menuSize} style={{whiteSpace:'nowrap'}}/>
              </Grid>
            </Hidden>

              <Hidden mdDown>
                <Grid item xs>
                  <HeaderLogin/>
                </Grid>
              </Hidden>
            </Grid>
          </header>
        }/>
      );
    }
  }

  export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx